import { createStructuredSelector, createSelector } from 'reselect'
import { orderBy, get, find } from 'lodash'

export const distributionOfDipsCard = ({ dashboard }) =>
  dashboard.getIn(['distributionOfFirmwareCard'], {})

export const firmwareVersion = createSelector(
  [distributionOfDipsCard],
  distributionOfDipsCard => distributionOfDipsCard.getIn(['firmwareAssetsId'], [])
  .map(firmwareVersion => firmwareVersion.getIn(['firmware'], ''))
)

export const details = createSelector(
  [distributionOfDipsCard],
  distributionOfDipsCard => distributionOfDipsCard.getIn(['firmwareAssetsId'], [])
  .map(details => details.getIn(['details'], []))
)

export const sites = ({ siteManager }) => siteManager.getIn(['rootSitesById'], [])


export const firmwareValue = createSelector(
  [distributionOfDipsCard],
  distributionOfDipsCard => distributionOfDipsCard.getIn(['totals'], [])
)

export const firmwarePtc = createSelector(
  [distributionOfDipsCard],
  distributionOfDipsCard => distributionOfDipsCard.getIn(['percentages'], [])
)

export const data = createSelector(
  firmwareVersion,
  firmwareValue,
  firmwarePtc,
  details,
  sites,
  (firmwareVersion, firmwareValue, firmwarePtc, details, sites) => {
    const detailsWithSites = details.map(detail => detail
      .map(value => ({
        tagIds: value.assetId,
        serialNumber: value.serialNumber,
        orgUnitKey: value.orgUnitKey,
        site: get(find(sites, { value: value.orgUnitKey }), 'text', ''),
      })))

    return orderBy(firmwareVersion.map((value, index) => {
      return {
        key: value || 'Unknown',
        value: firmwareValue[index],
        percentage: firmwarePtc[index],
        details: detailsWithSites[index]
      }
    }), ['value'], ['desc'])
  }
)

export default createStructuredSelector({
  data
})
